const MAX_MOBILE_WIDTH = 700;

export const getScreenWidth = () => window.screen.width;

export const getScreenHeight = () => window.screen.height;

export const isMobileView = () => getScreenWidth() <= MAX_MOBILE_WIDTH;